/* eslint-disable */

import { getCookie } from "tiny-cookie";
import { GetterTree } from "vuex";
import { RootState } from "@/types";
import { UserState } from "@/types/user";

const getters: GetterTree<UserState, RootState> = {
  isAuthorized: (state) => state.single!.id !== 0,
  accessToken: () => getCookie("access_token") || null,
  refreshToken: () => getCookie("refresh_token") || null,
  abilities: () => getCookie("abilities") || null,

  getState: (state) => {
    return state;
  },
  getAbilities: (state) => {
    return state.abilities;
  },

  isCompany: (state) => state.abilities == "role:company",
  isMember: (state) => state.abilities == "role:member",
  isSale: (state) => state.abilities == "role:sale",

  me: (state) => state.single,
};
export default getters;
